import * as React from "react";

const ChatIconSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill="#171718"
            d="M10 31V13q0-.824.587-1.413A1.93 1.93 0 0 1 12 11h16q.824 0 1.413.587Q30 12.175 30 13v12q0 .824-.587 1.413A1.93 1.93 0 0 1 28 27H14zm3.15-6H28V13H12v13.125zm-1.113 0V13z"
        ></path>
    </svg>
);

export default ChatIconSVG;
